export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";